import Character from "../character/Character";
import GridTile from "../grid/GridTile";
import LightSourceCreator from "../lighting/LightSourceCreator";
import Vector from "../math/Vector";
import SoundEffect from "../sound/SoundEffect";
import GervaisAnimatedSpritesheet from "../sprite/GervaisAnimatedSpritesheet";
import SpriteAnimation from "../sprite/SpriteAnimation";
import BasicSpriteEffect from "./BasicSpriteEffect";
import BasicSpriteEffectCache from "./BasicSpriteEffectCache";
import Effect from "./Effect";
import EffectCreator from "./EffectCreator";

export default class BasicSpriteEffectCreator extends EffectCreator {
    /**
     * 
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet
     * @param {string} spriteName
     * @param {SoundEffect} soundEffect
     * @param {LightSourceCreator} lightSourceCreator
     * @param {BasicSpriteEffectCache} basicSpriteEffectCache
     */
    constructor(spellFxSpritesheet, spriteName, soundEffect, lightSourceCreator, basicSpriteEffectCache) {
        super();

        /**
         * @constant
         * @type {GervaisAnimatedSpritesheet}
         */
        this.spellFxSpritesheet = spellFxSpritesheet;

        /**
         * @constant
         * @type {string}
         */
        this.spriteName = spriteName;

        /**
         * @type {SpriteAnimation}
         */
        this.spriteAnimation = null; // lazily loaded
        /**
         * @constant
         * @type {SoundEffect}
         */
        this.soundEffect = soundEffect;
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightSourceCreator = lightSourceCreator;
        /**
         * @constant
         * @type {BasicSpriteEffectCache}
         */
        this.basicSpriteEffectCache = basicSpriteEffectCache;
    }

    /**
     * @override
     * @param {Character} effectOwner 
     * @param {Vector} effectPosition 
     * @returns {Effect}
     */
    createEffect(effectOwner, effectPosition) {

        if (!this.spriteAnimation && this.spellFxSpritesheet) {
            this.spriteAnimation = this.spellFxSpritesheet.getSpriteAnimation(this.spriteName);
        }

        // /**
        //  * @type {LightSource}
        //  */
        // const lightSource = this.lightSourceCreator ? this.lightSourceCreator.createLightSource(this.findLightSourceTile(effectOwner, effectPosition)) : null;

        /**
         * @type {BasicSpriteEffect}
         */
        const effect = this.basicSpriteEffectCache.get();
        //////effect.set(effectOwner, this.spriteAnimation, effectPosition, this.soundEffect, lightSource);
        effect.set(effectOwner, this.spriteAnimation, effectPosition);
        return effect;
    }

    /**
     * @override
     * @param {Character} effectOwner 
     * @param {GridTile} tile
     * @returns {Effect}
     */
    createEffectAtTile(effectOwner, tile) {
        if (!this.spriteAnimation && this.spellFxSpritesheet) {
            this.spriteAnimation = this.spellFxSpritesheet.getSpriteAnimation(this.spriteName);
        }

        // /**
        //  * @type {LightSource}
        //  */
        // const lightSource = this.lightSourceCreator ? this.lightSourceCreator.createLightSource(tile) : null;

        /**
         * @type {BasicSpriteEffect}
         */
        const effect = this.basicSpriteEffectCache.get();
        //effect.set(effectOwner, this.spriteAnimation, tile.origin, this.soundEffect, lightSource);
        effect.set(effectOwner, this.spriteAnimation, tile.origin);
        return effect;
    }

    /**
     * @override
     * @param {Character} effectOwner 
     * @param {Vector} position The origin position (top left)
     * @returns {Effect}
     */
    createEffectAtPosition(effectOwner, position) {
        if (!this.spriteAnimation && this.spellFxSpritesheet) {
            this.spriteAnimation = this.spellFxSpritesheet.getSpriteAnimation(this.spriteName);
        }

        /**
         * @type {BasicSpriteEffect}
         */
        const effect = this.basicSpriteEffectCache.get();
        effect.set(effectOwner, this.spriteAnimation, position);
        return effect;
    }

    // /**
    //  * @private
    //  * @param {Character} effectOwner 
    //  * @param {Vector} effectPosition 
    //  * @returns {GridTile}
    //  */
    // findLightSourceTile(effectOwner, effectPosition) {
    //     return effectOwner.position.tile.getNeighbor(effectPosition);
    // }

    /**
     * @override
     * @returns {SpriteAnimation}
     */
    getSpriteAnimation() {
        return this.spriteAnimation;
    }
    
}